export const figure18a = {
chart: {
type: 'line',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
height: 230,
plotBackgroundColor: null,
plotBorderWidth: null,
},
credits: {
enabled: false
},
title: {
text: 'Uganda'
},
subtitle: {
text: null
},
xAxis: {
categories: ['2010', '2011', '2012', '2014', '2016', '2019']
},
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
yAxis: {
min: 0,
max: 20,
tickInterval: 4,
title: {
text: null,
},
},
plotOptions: {
series: {
marker: {
enabled: false,
states: {
hover: {
enabled: false
}
}
}
},		 
line: {
dataLabels: {
enabled: false
},
enableMouseTracking: true
}
},
legend: {
enabled: false,
},
colors: ['#5a99d3', '#f5b493','#a5a5a5', '#fdc201'],
series: [{
name: 'Pequeños productores',
data: [4.1, 3.5, 3.7, 3.3, 3.4, 8.5]
}, {
name: 'Productores no pequeños',
data: [6.4, 5.2, 5.6, 4.2, 4.4, 15.0]
},{
name: 'Unidades de pequeños productores dirigidas por mujeres',
data: [3.7, 3.4, 3.2, 3.7, 3.1, 10.8]
},{
name: 'Unidades de pequeños productores dirigidas por hombres',
data: [4.3, 3.5, 4.0, 3.0, 3.5, 7.6]
}]
}

